import { render, staticRenderFns } from "./IsoDate.vue?vue&type=template&id=42e79e04&"
import script from "./IsoDate.vue?vue&type=script&lang=js&"
export * from "./IsoDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e79e04')) {
      api.createRecord('42e79e04', component.options)
    } else {
      api.reload('42e79e04', component.options)
    }
    module.hot.accept("./IsoDate.vue?vue&type=template&id=42e79e04&", function () {
      api.rerender('42e79e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/IsoDate.vue"
export default component.exports